import React, { useCallback, useEffect, useRef, useState } from 'react'
import s from './FPS.less'

const now = () => (performance || Date)['now']()

const FPS = () => {
  const [fps, setFps] = useState('')

  const stop = useRef(false)
  const t0 = useRef(now())
  const counter = useRef(0)
  const interval = useRef(null)

  const updateFpsCount = useCallback(() => {
    const deltaTime = now() - t0.current
    const fps = counter.current / (deltaTime * 0.001)

    setFps(fps.toFixed(1))

    t0.current = now()
    counter.current = 0
  }, [])

  const compute = useCallback(() => {
    counter.current = 0
    t0.current = now()

    const count = () => {
      if (stop.current) return
      counter.current++
      requestAnimationFrame(count)
    }
    requestAnimationFrame(count)
  }, [])

  useEffect(() => {
    interval.current = setInterval(updateFpsCount, 600)
    return () => {
      clearInterval(interval.current)
    }
  }, [updateFpsCount])

  useEffect(() => {
    compute()
    return () => {
      stop.current = true
    }
  }, [compute])

  return <div className={s.main}>{fps} fps</div>
}

export default FPS
